import { connect } from 'react-redux';

import { getIsSourceTimeoutFixEnabled } from 'src/selectors/feature-selectors';
import { BucketState } from 'src/types/state';

import { filterFiles } from '../actions/filter-files';
import FilteredFileList from '../components/file-filter';
import { getFilteredFiles } from '../reducers/section';

const mapStateToProps = (state: BucketState) => ({
  filteredFiles: getFilteredFiles(state),
  sourceTimeoutFixEnabled: getIsSourceTimeoutFixEnabled(state),
});

const mapDispatchToProps = {
  onUnmount: filterFiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilteredFileList);
